// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"844cf657","118":"2298175f","142":"43d60c11","163":"a2650314","221":"bdebf814","223":"cf8d3746","226":"ba12f3f8","369":"a050939d","453":"41811d64","663":"be634263","926":"26d9b724","952":"a081130e"}[chunkId] + ".chunk.js";
};